import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Card from '@material-ui/core/Card';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import { startEditProject } from '../../../../store/actions/projects';

const styles = theme => ({
  root: {
    width: '400px',
    margin: theme.spacing.unit,
  },
  field: {
    width: '95%',
    margin: theme.spacing.unit,
  }
});

const JobDescription = ({ classes, project }) => {
  return (
    <Card className={classes.root}>
      <TextField
        className={classes.field}
        margin="dense"
        id="name"
        label="Description/Solution"
        fullWidth
        multiline={true}
        rows={6}
        value={project.jobDescription}
        onChange={(event) => startEditProject(project.id, {jobDescription: event.target.value})}
      />
    </Card>
  );
};

const mapDispatchToProps = (dispatch) => ({
  startEditProject: (projectId, updates) => dispatch(startEditProject(projectId, updates)),
});

export default compose(
  withStyles(styles),
  connect(null, mapDispatchToProps),
)(JobDescription);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Detail/JobDescription.jsx